import { FC, useEffect } from 'react';
import { PreloadedQuery, UseQueryLoaderLoadQueryOptions } from 'react-relay';
import {
  IndividualStudentReportOverallQuery,
  IndividualStudentReportOverallQuery$variables,
} from '../../graphQLOperations/__generated__/IndividualStudentReportOverallQuery.graphql';

import { IndividualStudentReportCards } from './IndivudalStudentReportCards';
import { splitId } from '../../businessLogicService/splitIdsFromBackEnd';

interface Props {
  id: string;
  queryReferenceProjection:
    | PreloadedQuery<IndividualStudentReportOverallQuery, Record<string, unknown>>
    | null
    | undefined;
  loadOverallProjection: (
    variables: IndividualStudentReportOverallQuery$variables,
    options?: UseQueryLoaderLoadQueryOptions,
  ) => void;
  diagnostic?: { id: string; retakeAssigned: boolean } | null;
}

export const IndividualStudentProjection: FC<Props> = ({
  queryReferenceProjection,
  loadOverallProjection,
  id,
  diagnostic,
}) => {
  useEffect(() => {
    loadOverallProjection({ userId: `UserNode:${splitId(id)}` }, { fetchPolicy: 'network-only' });
  }, [id]);

  return (
    <>
      {queryReferenceProjection && (
        <IndividualStudentReportCards diagnostic={diagnostic} queryReferenceProjection={queryReferenceProjection} />
      )}
    </>
  );
};
